// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1tNCY","title":"AfterFrontImage_title__36i60"};